(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("PhotoSwipe", [], factory);
	else if(typeof exports === 'object')
		exports["PhotoSwipe"] = factory();
	else
		root["PhotoSwipe"] = factory();
})(window, function() {
return 